import { Tag } from 'antd';
import apiFundDistributorProductsListCall from 'apps/catalog/apiCalls/fund-distributor-products/list';
import { companyColors } from 'apps/investment/constants';
import { DataTable } from 'common/data-table';
import BooleanIcons from 'common/ui/boolean-icons';
import ErrorMessage from 'common/ui/ErrorMessage';
import InfoCard from 'common/ui/info-card';
import { useFetchApiList } from 'hooks/api';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { formatDateTime } from 'utils/formatDate';
import { cloudflareCdn } from 'utils/image';
import { columnsGenerator as columnsGeneratorFundDistributorProducts } from '../fund-distributor-products/config';

const ItemDetail = ({ item }) => {
  const {
    id,
    code,
    name,
    short_name,
    description,
    term_condition_url,
    logo,
    is_default,
    is_econtract_required,
    ordering,
    created_at,
    updated_at,
    estimate_provider,
    fulfillment_order_provider,
    auth_provider,
  } = item || {};

  const {
    data: fundDistributorProducts,
    error: errorFundDistributorProducts,
    load: loadFundDistributorProducts,
  } = useFetchApiList(apiFundDistributorProductsListCall, {
    resourceName: 'data',
  });

  useEffect(() => {
    if (id) loadFundDistributorProducts({ fund_distributor_id: id });
  }, [id]);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="flex gap-4">
          {logo ? (
            <img
              src={cloudflareCdn(logo, 100)}
              alt="Logo"
              className="w-14 rounded object-contain"
            />
          ) : null}
          <InfoCard
            className="flex-grow"
            label="Code"
            value={code ? <Tag color={companyColors[code]}>{code}</Tag> : '-'}
          />
        </div>

        <InfoCard label="Tên" value={short_name || '-'} />
        <InfoCard label="Tên đầy đủ" value={name || '-'} />
        <InfoCard
          className="md:col-span-3"
          label="Mô tả"
          value={description || '-'}
        />

        <InfoCard label="Auth Provider" value={auth_provider || '-'} />
        <InfoCard label="Estimate Provider" value={estimate_provider || '-'} />
        <InfoCard
          label="Fulfillment Order Provider"
          value={fulfillment_order_provider || '-'}
        />
        <InfoCard
          label="Điều khoản"
          value={
            term_condition_url ? (
              <a
                href={term_condition_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Mở liên kết
              </a>
            ) : (
              '-'
            )
          }
        />
        <InfoCard
          label="Mặc định"
          value={<BooleanIcons value={!!is_default} />}
        />
        <InfoCard
          label="Yêu cầu e-contract"
          value={<BooleanIcons value={!!is_econtract_required} />}
        />
        <InfoCard label="Created At" value={formatDateTime(created_at)} />
        <InfoCard label="Updated At" value={formatDateTime(updated_at)} />
      </div>

      <h3 className="text-base font-medium text-gray-800 pt-2 border-b flex items-center">
        Danh sách phân phối
      </h3>
      {!!errorFundDistributorProducts ? (
        <ErrorMessage errors={errorFundDistributorProducts} />
      ) : (
        <div>
          <DataTable
            noViewOptions
            containerClassName="max-h-[30vh]"
            data={fundDistributorProducts || []}
            columns={columnsGeneratorFundDistributorProducts()}
          />
          <div className="flex justify-center text-base font-medium py-1">
            <Link
              to={`/admin/fund-distributor-products?fund_distributor_id=${id}`}
            >
              Xem tất cả
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemDetail;
